// The bell's way back to the briefing: one button, shown only to people authorised for Orders.
// It reads the briefing store only (the gate publishes allowed + count), so it needs no query client.
import React from 'react';
import { useBriefingStore } from './briefingStore';
import styles from './briefing.module.css';

export function BriefingEntry({ onBefore }) {
  const allowed = useBriefingStore((s) => s.allowed);
  const count = useBriefingStore((s) => s.count);
  const request = useBriefingStore((s) => s.request);
  if (!allowed) return null;
  return (
    <button type="button" className={styles.entry} data-test="briefing-entry"
      onClick={() => { if (onBefore) onBefore(); request(); }}>
      <span className={styles.entryDot} aria-hidden="true" />
      <b>Morning briefing</b>
      <span>{count ? `${count} from Orders` : 'Nothing new from Orders'}</span>
    </button>
  );
}

export default BriefingEntry;
